export default [
  { 
    value: 'ADD_DOCUMENT', 
    label: 'Add Document', 
    category: 'DOCUMENTS' 
  }
]